import { ApolloLink } from '@apollo/client';
import { getMainDefinition } from 'apollo-utilities';

import { invalidateSharedQueries } from './sharedQuery';

/**
 * Results shared between imperative query hooks (`./sharedQuery`) must not
 * outlive a write: drop them when any mutation starts and again when it
 * lands, so a request issued meanwhile is not reused either.
 */
export const invalidateOnMutationLink = new ApolloLink((operation, forward) => {
  const definition = getMainDefinition(operation.query) as {
    kind: string;
    operation?: string;
  };
  if (
    definition.kind !== 'OperationDefinition' ||
    definition.operation !== 'mutation'
  ) {
    return forward(operation);
  }
  invalidateSharedQueries();
  return forward(operation).map((result) => {
    invalidateSharedQueries();
    return result;
  });
});
